// extracted by mini-css-extract-plugin
export var authorSectionInnerStyle = "blog_post_author_section-module--authorSectionInnerStyle--5G8ua";
export var authorSectionWrapperStyle = "blog_post_author_section-module--authorSectionWrapperStyle--4YG1I";